
import { Layout, Space, Card, message, List, Spin, Button, Modal, Dropdown, Menu } from 'antd';
import Search from 'antd/es/input/Search';
import { ReloadOutlined, CheckCircleOutlined, LogoutOutlined, QrcodeOutlined, 
  UserOutlined, } from '@ant-design/icons';
import request from '../utils/request';
import ShopInfo from '../components/ShopInfo/ShopInfo';
import "./Myshop.css"
import { useEffect, useRef, useState, useMemo } from 'react';
import { useAtom } from 'jotai';
import { loggedInUserAtom, storesAtom } from '../store/userAtom';
import { statisticsStore, visibleStore } from '../api/store';
import { useLocation, useNavigate } from 'react-router-dom';
import Quagga from 'quagga';


const { Header } = Layout;
const headerStyle = {
  textAlign: 'center',
  color: '#fff',
  height: 64,
  paddingInline: 48,
  lineHeight: '64px',
  backgroundColor: '#ED4948',
};
const contentStyle = {
  padding: '24px',
  width: '100%',
  boxSizing: 'border-box',

}


const MyShop = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [stores, setStores] = useState([]);
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const [loading, setLoading] = useState(false);
  const [healthStatus, setHealthStatus] = useState({});
  const [storeAtom, setStoresAtom] = useAtom(storesAtom)
  const [loggedInUser, setLoggedInUser] = useAtom(loggedInUserAtom);
  const [messageApi, contextHolder] = message.useMessage();
  const [isScanModalVisible, setIsScanModalVisible] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const scannerRef = useRef(null);
  const [scanInput, setScanInput] = useState('');
  const [isPermissionModalVisible, setIsPermissionModalVisible] = useState(false);


  const onSearch = async (value, _e, info) => {
    if (value.trim()) {
      navigate('/my-shop-two', { state: { code: value.trim() } });
    } else {
      messageApi.warning("请输入搜索内容");
    }
  };

  // 获取用户信息并处理认证
  useEffect(() => {
    setCurrentPath(location.pathname);
    // 不需要请求用户信息的路径
    const authPaths = ['/login', '/register', '/forget'];
    if (authPaths.includes(location.pathname)) {
      return;
    }

    const fetchUserInfo = async () => {

      try {
        const response = await request({
          url: '/user_info',
          method: 'get'
        });
        setLoggedInUser(response.data);
      // 获取用户信息后立即检查权限
      const permissions = response.data.permissions || [];
      if (permissions.length === 0) {
        console.log("===== 权限为空，设置弹框可见");
        setIsPermissionModalVisible(true);
      }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // 清除本地存储并重定向到登录页
          localStorage.removeItem('token');
          setLoggedInUser(null);
          messageApi.error('登录已过期，请重新登录');
          navigate('/login');
        } else {
          messageApi.error('获取用户信息失败');
          console.error('获取用户信息失败:', error);
        }
      }
    };

    // 如果有token，则获取用户信息
      const token = localStorage.getItem('token');
      if (token) {
        fetchUserInfo();
      }
    }, [navigate, setLoggedInUser, messageApi]);

  // 移除独立的权限检查useEffect，统一在fetchUserInfo中处理
  // useEffect(() => {
  //   console.log('权限检查触发，当前用户信息:', loggedInUser);
  //   if (loggedInUser) {
  //     const permissions = loggedInUser.permissions || [];
  //     console.log('用户权限数组:', permissions);
  //     if (permissions.length === 0) {
  //       console.log("===== 权限为空，设置弹框可见");
  //       setIsPermissionModalVisible(true);
  //     }
  //   }
  // }, [loggedInUser]);

  const fetchStores = async () => {

    if (!loggedInUser?.user_id) {
      messageApi.warning('用户信息加载中，请稍候...');
      return;
    }
    setLoading(true);
    try {
      const response = await visibleStore(loggedInUser.user_id);
      // 原始店铺数据
      const storesData = response.data || [];
      const statisticsPromises = storesData.map(store => statisticsStore(store.address));

      let updatedStores = []
      statisticsPromises.forEach((promise, promiseIndex) => {
        promise.then(response => {
          const orginShopData = storesData[promiseIndex];
          updatedStores = [
            ...updatedStores,
            {
              ...orginShopData,
              ...response.data,
              rest: false,
              updated: true
            }
          ]

          setStores(updatedStores);
          setStoresAtom(updatedStores);
        }).catch((error) => {
          const orginShopData = storesData[promiseIndex];
          updatedStores = [
            ...updatedStores,
            {
              ...orginShopData,
              rest: true,
              updated: true
            }
          ];

          setStores(updatedStores);
          setStoresAtom(updatedStores);
        })
      })

      return updatedStores;
    } catch (error) {
      messageApi.error('获取店铺列表失败: ' + (error.response?.data?.message || error.message));
      return [];
    } finally {
      setLoading(false);
    }
  };


  const startScanner = async () => {
    await new Promise(resolve => setTimeout(resolve, 100));
    if (!scannerRef.current) return;
    Quagga.init({
      inputStream: {
        name: "Live",
        type: "LiveStream",
        target: scannerRef.current,
        constraints: { facingMode: "environment" }
      },
      decoder: { readers: ["ean_reader"], debug: { showCanvas: true } }
    }, (err) => {
      if (err) { messageApi.error(`初始化扫码失败: ${err}`); return; }
      Quagga.start();
      setIsScanning(true);
    });

    Quagga.onDetected((result) => {
      if (result && result.codeResult) {
        stopScanner();
        const code = result.codeResult.code;
        setScanInput(code);
        setIsScanModalVisible(false);
        messageApi.success("扫码成功");
        navigate('/product-detail', { state: { code } });
      }
    });
  };

  const stopScanner = () => {
    if (isScanning) { Quagga.stop(); setIsScanning(false); }
  };

  const checkAllStoresHealth = async (storesList) => {
    if (!storesList.length) return;
    const initialStatus = {};
    storesList.forEach(store => initialStatus[store.id] = 'checking');
    setHealthStatus(initialStatus);
    //storesList.forEach(store => checkStoreHealth(store.id, store.address));
  };

  const hasPermission = useMemo(() => {
    return loggedInUser?.permissions?.includes(2) || false;
  }, [loggedInUser?.permissions]);

  useEffect(() => {

    const init = async () => {

      const storesList = await fetchStores();
      checkAllStoresHealth(storesList);
    };

    // 仅当权限包含2时才获取店铺列表
    if (loggedInUser?.user_id && hasPermission) init();
  }, [loggedInUser?.user_id, hasPermission, messageApi]);

  const goNextPage = (ipAddress) => {
    navigate("/shop-details?ip=" + ipAddress)
  }

  const showScanModal = () => setIsScanModalVisible(true);


  useEffect(() => () => stopScanner(), [isScanning]);

  useEffect(() => {
    if (isScanModalVisible) startScanner();
    else stopScanner();
  }, [isScanModalVisible]);

  const scanButton = () => {
    return (<div onClick={showScanModal} className="scan-button">
      <QrcodeOutlined style={{ color: "#E0A52B" }} />
    </div>)
  }
  // 退出登录处理
  const handleLogout = () => {
    localStorage.removeItem('token');
    setLoggedInUser(null);
    navigate('/login', { replace: true });
  };

    // 用户下拉菜单
  const userMenu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        退出登录
      </Menu.Item>
    </Menu>
  );
  return (
      <div>
        {/* 权限提示模态框 */}
        <Modal
    title="权限提示"
    open={isPermissionModalVisible}
    onOk={handleLogout}
    footer={[
      <Button key="ok" type="primary" onClick={handleLogout}>
        确定
      </Button>
    ]}
    maskClosable={false}
    style={{ zIndex: 9999, backgroundColor: '#fff', border: '2px solid red' }}
  >
          <p style={{ fontSize: '16px', color: '#333' }}>请联系管理员设置权限</p>
        </Modal>
      <Header 
        style={{
          background: "#fff",
          padding: "0 10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
  color: '#fff',
  height: 64,
  paddingInline: 48,
  lineHeight: '64px',
  backgroundColor: '#ED4948',
        }}>
          <div style={{
            
            width: "91px"
          }
          }></div>
          <div>我的店铺</div>




        

        {loggedInUser?.username ? (
          <Dropdown overlay={userMenu} placement="bottomRight">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "0 16px",
              }}
            >
              <UserOutlined style={{ marginRight: 4 }} />
              <span>{loggedInUser.username}</span>
            </div>
          </Dropdown>
        ) : (
          <div style={{ display: "flex", gap: 16 }}>
            <Button 
              onClick={() => navigate('/login')}
             style={{ color: "#fff", background: "#1890ff", padding: "6px 16px", borderRadius: 4, cursor: "pointer" }}>
              登录
            </Button>
            <Button onClick={() => navigate('/register')} style={{ color: "#1890ff", border: "1px solid #1890ff", padding: "6px 16px", borderRadius: 4, cursor: "pointer" }}>
              注册
            </Button>
          </div>
        )}
      </Header>
      <Space direction="vertical" style={contentStyle} size={"large"}>
        {loggedInUser?.permissions?.includes(1) && (
          <div>
            <Search
              style={{ width: "100%" }}
              addonBefore={scanButton()}
              className='search-bar'
              placeholder="请输入条形码"
              allowClear
              enterButton="搜索"
              size="large"
              onSearch={onSearch}
            />
          </div>
        )}

        {/* <Button type="primary" icon={<QrcodeOutlined />} onClick={showScanModal}>扫码</Button> */}

        <Modal
          title="扫码"
          open={isScanModalVisible}
          onCancel={() => { setIsScanModalVisible(false); stopScanner(); }}
          footer={null}
          width={700}
          destroyOnHidden={true}
        >
          <div ref={scannerRef} style={{ width: '100%', height: '500px', position: 'relative' }}>
            {!isScanning && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>加载中...</div>
            )}
          </div>
        </Modal>

        {loggedInUser?.permissions?.includes(2) && (
          <Spin spinning={loading} tip="加载中...">
            <List
              grid={{ gutter: 16, column: 1, xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }}
              dataSource={stores}
              renderItem={store => {
                return store.rest ?
                  (<List.Item >
                    <Card title={`店铺: ${store.store_name || '未命名'}`}  >
                      <p>店铺休息中</p>
                    </Card></List.Item>)
                  : (
                    <List.Item onClick={() => goNextPage(store.address)}>
                      <Card title={`店铺: ${store.store_name || '未命名'}`} >
                        {/* <p>店铺休息中</p> */}
                        <ShopInfo info={store} />
                      </Card>
                    </List.Item>
                  )
              }}
            />
            {stores.length === 0 && !loading && (
              <div style={{ textAlign: 'center', padding: '50px' }}><p>暂无店铺数据</p></div>
            )}
          </Spin>
        )}

        {/* <Card title="测试一号店" variant="borderless" size='small'>
          <p>店铺休息中</p>
        </Card> */}


      </Space>
    </div>
  );
};


export default MyShop;
